import { Module } from "vuex";
import * as firebase from "firebase";
import {serializer} from "@/api/shared/serializer";
import {getRegionName} from "@/utils/functionsRegion";
import { Document } from "@/models/documents/Document";
import { DocumentCategory } from "@/models/documents/DocumentCategory";

const documentsModule: Module<any, any> = {
  namespaced: false,
  state: {
    documents: [],
    document: {},
    documentsCategories: []
  },
  mutations: {
    setDocuments(state: any, payload: Document) {
      state.documents = payload;
    },
    setDocument(state: any, payload: Document) {
      state.document = payload;
    },
    setDocumentsCategories(state: any, payload: DocumentCategory) {
      state.documentsCategories = payload;
    },
  },
  actions: {
    async getDocuments({ commit }) {
      await firebase
        .firestore()
        .collection('documents')
        .where('facilityId', '==', this.state.authModule.currentFacility).get()
        .then((querySnapshot: any) => {
          let items = serializer.querySnapshotToDocuments<any>(querySnapshot)
          items = items.map(x=>({categoryNames: (x.categories? x.categories.map(x=>x.name).join(", "):[]) ,...x}))
          commit('setDocuments', items);
        });
    },

    async getDocument({ commit }, documentId: string) {
      await firebase
        .firestore()
        .collection('documents')
        .doc(documentId)
        .get()
        .then((documentSnapshot: any) => {
          const document = serializer.documentSnapshotToDocument(documentSnapshot)
          commit('setDocument', document);
        });
    },

    async addDocument(_, document: Document) {
      if (!document) return;

      const response = await firebase.app().functions(getRegionName()).httpsCallable('utils-addOrgDocument')({
        orgId: this.state.authModule.currentFacilityData.orgId,
        collectionName: 'documents',
        document: document
      });

      return response.data;
    },

    async deleteDocument(_, document: Document) {
      if (!document || !document.id) return

      const snap = await firebase.firestore().collection("documents").doc(document.id).get()

      if(snap.exists){
        return await snap.ref.delete();
      }

      return;
    },

    async getDocumentsCategories({ commit }) {
      const items = firebase
        .firestore()
        .collection('documentsCategories')
        .where('facilityId', '==', this.state.authModule.currentFacility);

      return await items.get().then(querySnapshot => {
        commit('setDocumentsCategories', serializer.querySnapshotToDocuments<any>(querySnapshot));
      });
    },

    async addDocumentsCategories({ dispatch }, categories: DocumentCategory[]) {
      if (!categories || !categories.length) return;

      const db = firebase.firestore();
      const batch = db.batch();

      for (let i = 0; i < categories.length; i++) {
        const docRef = db.collection('documentsCategories').doc();

        batch.set(docRef, { ...categories[i] });
      }

      const result = await batch.commit()
      return result;
    },

    async deleteDocumentsCategories({ commit, state }, data) {
      const { categories, facilityId } = data;
      if (!categories || !categories.length) return;

      const db = firebase.firestore();
      const batch = db.batch();
      for(const doc of categories) {
        if (doc.id) {
          const docRef = await db.collection('documentsCategories').doc(doc.id);

          await db.collection('documents')
            .where('facilityId', '==', facilityId)
            .where('categoryIds', 'array-contains', doc.id)
            .get()
            .then(async (querySnapshot) => {
              for (const item of querySnapshot.docs) {
                const document = item.data()
                const categories = document.categories.filter(x => x.id !== doc.id);
                await firebase.firestore().collection('documents')
                  .doc(item.id)
                  .update({
                    categories: categories,
                    categoryIds: categories.map(x => x.id)
                  });
              }
            });
          batch.delete(docRef);
        }
      }
      const result = await batch.commit();
      return result
    },

    async updateDocumentsCategories({ commit }, categories: DocumentCategory[]) {
      if (!categories || !categories.length) return;

      const db = firebase.firestore();
      const batch = db.batch();
      categories.forEach(doc => {
        const docRef = firebase
          .firestore()
          .collection('documentsCategories')
          .doc(doc.id);
        const name = categories.find(x => x.id == doc.id).name;
        batch.update(docRef, { name: name });

        db.collection('documents')
          .where('facilityId', '==', this.state.authModule.currentFacility)
          .where('categoryIds', 'array-contains', doc.id)
          .get()
          .then((querySnapshot) => {
            querySnapshot.docs.forEach((item) => {
              const media = item.data()
              const categories = media.categories.filter(x => x.id !== doc.id);
              const editCategory = media.categories.filter(x => x.id === doc.id)[0];
              editCategory.name = doc.name;
              db.collection('documents')
                .doc(item.id)
                .update({'categories': [editCategory, ...categories]});
            })
          });
      });
      return await batch.commit();
    },
  }
}

export default documentsModule;